var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaturazione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-invoice-4748875",
    d: "M201.933,76.786,200.329,75l-1.6,1.786L197.122,75l-1.6,1.786L193.915,75l-1.6,1.786L190.707,75l-1.6,1.786-1.6-1.75V95l1.6-1.786,1.6,1.786,1.6-1.786,1.6,1.786,1.6-1.786,1.6,1.786,1.6-1.786,1.6,1.786,1.6-1.786,1.567,1.75V75Zm-7.144,11.786h-3.1a.714.714,0,1,1,0-1.429h3.1a.714.714,0,1,1,0,1.429Zm4.556-2.857h-7.654a.714.714,0,1,1,0-1.429h7.654a.714.714,0,1,1,0,1.429Zm0-2.857h-7.654a.714.714,0,1,1,0-1.429h7.654a.714.714,0,1,1,0,1.429Z",
    transform: "translate(-187.5 -75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaturazione);
export default __webpack_public_path__ + "static/media/faturazione.74f765718f168e620bc122dd8fc7604a.svg";
export { ForwardRef as ReactComponent };